import { useParams } from "react-router-dom";
import { Construction, ShieldOff } from "lucide-react";
import { EmptyState, PageHeader, Panel, RowsSkeleton } from "@/components/app/kit";
import { useFetch } from "@/hooks/useServerList";
import { useAuth } from "@/context/AuthContext";

export default function ModulePage() {
  const { code } = useParams();
  const { me } = useAuth();
  const mod = me.modules.find((m) => m.code === code);
  const { data, loading, error } = useFetch(`/t/modules/${code}/access`);
  if (loading) return <RowsSkeleton />;
  if (error) return <EmptyState icon={ShieldOff} testid="module-blocked" title="Module non activé" text={error} />;
  return (
    <div>
      <PageHeader eyebrow={`Module · ${code}`} title={mod?.name || code} />
      <Panel testid="module-placeholder">
        <EmptyState icon={Construction} title="Module autorisé pour votre cabinet"
          text={data?.allowed ? "L'accès est validé par le serveur. Les fonctionnalités de ce module seront livrées dans une prochaine phase du projet." : ""} />
      </Panel>
    </div>
  );
}
